 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		115: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"lang-_es","1":"lang-af","2":"lang-am","3":"lang-ar","4":"lang-az","5":"lang-be","6":"lang-bg","7":"lang-bn","8":"lang-bs","9":"lang-ca","10":"lang-ceb","11":"lang-co","12":"lang-cs","13":"lang-cy","14":"lang-da","15":"lang-de","16":"lang-el","17":"lang-en","18":"lang-eo","19":"lang-et","20":"lang-eu","21":"lang-fa","22":"lang-fi","23":"lang-fr","24":"lang-fy","25":"lang-ga","26":"lang-gd","27":"lang-gl","28":"lang-gu","29":"lang-ha","30":"lang-haw","31":"lang-he","32":"lang-hi","33":"lang-hmn","34":"lang-hr","35":"lang-ht","36":"lang-hu","37":"lang-hy","38":"lang-id","39":"lang-ig","40":"lang-is","41":"lang-it","42":"lang-iw","43":"lang-ja","44":"lang-jw","45":"lang-ka","46":"lang-kk","47":"lang-km","48":"lang-kn","49":"lang-ko","50":"lang-ku","51":"lang-ky","52":"lang-la","53":"lang-lb","54":"lang-lo","55":"lang-lt","56":"lang-lv","57":"lang-mg","58":"lang-mi","59":"lang-mk","60":"lang-ml","61":"lang-mn","62":"lang-mr","63":"lang-ms","64":"lang-mt","65":"lang-my","66":"lang-ne","67":"lang-nl","68":"lang-no","69":"lang-ny","70":"lang-pa","71":"lang-pl","72":"lang-ps","73":"lang-pt","74":"lang-ro","75":"lang-ru","76":"lang-sd","77":"lang-si","78":"lang-sk","79":"lang-sl","80":"lang-sm","81":"lang-sn","82":"lang-so","83":"lang-sq","84":"lang-sr","85":"lang-st","86":"lang-su","87":"lang-sv","88":"lang-sw","89":"lang-ta","90":"lang-te","91":"lang-tg","92":"lang-th","93":"lang-tl","94":"lang-tr","95":"lang-uk","96":"lang-ur","97":"lang-uz","98":"lang-vi","99":"lang-xh","100":"lang-yi","101":"lang-yo","102":"lang-zh-CN","103":"lang-zh-TW","104":"lang-zu","105":"vendors/pages/_lang/_id/_name/pages/_lang/new","108":"pages/_lang/_id/_name","109":"pages/_lang/about","110":"pages/_lang/all","111":"pages/_lang/index","112":"pages/_lang/logged","113":"pages/_lang/new","114":"pages/index","117":"vendors/pages/_lang/_id/_name","118":"vendors/pages/_lang/index"}[chunkId]||chunkId) + "." + {"0":"557c3cc","1":"1873d45","2":"80595b9","3":"bd3ae87","4":"f78dcd0","5":"63cb9f8","6":"934fbe7","7":"27eebbf","8":"46a5a3b","9":"d05301a","10":"dc59f5d","11":"6052716","12":"e9e57d5","13":"4f3456f","14":"4faa351","15":"0dbf586","16":"aa2dee0","17":"30252c1","18":"c1708cc","19":"9c8734e","20":"467715e","21":"d3db915","22":"b35fc91","23":"52c8666","24":"c729a6c","25":"ee1290a","26":"f3da220","27":"6966030","28":"6afb090","29":"b5d2eee","30":"69ff945","31":"98f3c27","32":"f67458a","33":"d54a579","34":"fe0b076","35":"e7f088d","36":"3dd975c","37":"4c23e56","38":"c850714","39":"485daa7","40":"d08f094","41":"c62ff76","42":"20ad463","43":"5d08807","44":"1cbaed9","45":"a425dc8","46":"ecf77ef","47":"7b27650","48":"20c83b7","49":"a526826","50":"d017d11","51":"aae2773","52":"24ee93e","53":"df9668b","54":"5842708","55":"595987e","56":"a54faea","57":"6f32b7c","58":"3f30d97","59":"1aba717","60":"ef4ac5c","61":"3ce82c3","62":"d0b0f34","63":"1c3ca6a","64":"97dd5b3","65":"847a18e","66":"51d0b2f","67":"953b6d6","68":"7b56c46","69":"aafd126","70":"57e33de","71":"72f23b0","72":"7e0ebb0","73":"da84736","74":"0daf6ad","75":"99c12ad","76":"f8c4783","77":"90fed76","78":"4b9d07d","79":"3a76980","80":"315669b","81":"4866f49","82":"e44e033","83":"217394b","84":"26e164d","85":"ea6d9c4","86":"22c985c","87":"0e6379f","88":"08cc278","89":"1caf2d1","90":"0434c53","91":"b5e7b5b","92":"d0e1994","93":"cee32f5","94":"c0e70a4","95":"4ce8cfa","96":"1b9ae7d","97":"d7958da","98":"2532540","99":"6031bcf","100":"cdc6c79","101":"7955f20","102":"55312ae","103":"b0fdfe2","104":"16464d0","105":"15a3ae4","108":"57e368a","109":"8c6d0d9","110":"7ed7ae5","111":"59cb8f1","112":"d98a9df","113":"b0de8b0","114":"46b17f0","117":"53791a2","118":"aea459f","119":"9dd5b12","120":"8ae32ec","121":"26730dc","122":"5518aa5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
